import React, { useState } from "react";
import { RouteComponentProps } from "react-router";
import { Button, Container } from "reactstrap";
import { isPhone } from "@cadmakers-ui/core";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackCategory, FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import { SearchContextType } from "../../../Layout/Constants/LayoutEnums";
import ActiveTopicName from "../ActiveTopicName";
import SubscribeToTopicButton from "../SubscribeButton/SubscribeToTopicButton";
import "../../Styles/TopicFeatureRequestsContainer.scss";
import { ApiRequest, useShowSnack } from "../../../Common";
import { endpoints } from "../../Constants/endpoints";
import { ResponseResult } from "../../../Common/Models/ResponseResult";
import ResponseHandler from "../../../App/ResponseHandler";

type TParams = {
  topicCode: string;
};

const CLASSNAME_PREFIX = "TopicFeatureRequestsContainer__";
const FEATURE_REQUEST = [FeedbackCategory.FeatureRequest];

const TopicFeatureRequestsContainer: React.FC<RouteComponentProps<TParams>> = props => {
  const [numSubscribers, setNumSubscribers] = useState(0);
  const [isLoadedNumSubscribers, setIsLoadedNumSubscribers] = useState(false);
  const showSnack = useShowSnack();

  const getNumSubscribers = () => {
    ApiRequest.fromPath(endpoints.subscriptions.getSubscriberCount(props.match.params.topicCode))
      .withAuthHeader()
      .get()
      .then((response: Response) => {
        ResponseHandler.handle(
          response,
          (result: ResponseResult) => {
            // dispatch an action to update it
            setNumSubscribers(result.payload);
            setIsLoadedNumSubscribers(true);
          },
          (result: ResponseResult) => {
            const label = "Cannot retrieve number of subscribers.";
            showSnack("TOPIC_SUBSCRIBER_COUNT", {
              label,
              timeout: 2000
            });
          }
        );
      });
  };

  getNumSubscribers();

  return (
    <Container fluid>
      <div className={`${CLASSNAME_PREFIX}heading`}>
        <span className={`${CLASSNAME_PREFIX}heading-title`}>
          {!isPhone && (
            <h2>
              <ActiveTopicName /> Feature Requests
            </h2>
          )}
        </span>
        {!isPhone && (
          <div className={`${CLASSNAME_PREFIX}heading-subscribe`}>
            <div>
              <SubscribeToTopicButton
                topicCode={props.match.params.topicCode}
                onClick={getNumSubscribers}
              />
            </div>
            {isLoadedNumSubscribers && (
              <div style={{ fontSize: "12px" }}>Number of Subscribers: {numSubscribers}</div>
            )}
          </div>
        )}
      </div>
      <FeedbackListContainer
        context={{ type: SearchContextType.Topic, itemId: props.match.params.topicCode }}
        listId={`TOPIC_ALL_FEATURE_REQUESTS_LIST${props.match.params.topicCode}`}
        sort={FeedbackSortOption.DateCreated}
        isAscending={false}
        reorderable
        fullscreen
        enableDownload
        treeView
        selectedCategories={FEATURE_REQUEST}
      />
    </Container>
  );
};

export default TopicFeatureRequestsContainer;
